import { render, staticRenderFns } from "./NotSent.vue?vue&type=template&id=758105e8&"
import script from "./NotSent.vue?vue&type=script&lang=js&"
export * from "./NotSent.vue?vue&type=script&lang=js&"
import style0 from "./NotSent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports